// extracted by mini-css-extract-plugin
module.exports = {"landscape-mode":"landscape-mode_landscape-mode__UBhyO","info":"landscape-mode_info__gwKXw"};